"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeProvider = exports.ThemeContext = void 0;
/*
 * Copyright 2026, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
// TODO: We could refactor this to an API or something like that in the future, so we won't use chaire-lib-common anymore
const Preferences_1 = __importDefault(require("chaire-lib-common/lib/config/Preferences"));
/**
 * Returns the system color scheme when available, otherwise 'dark'.
 */
function getSystemTheme() {
    if (typeof window === 'undefined' || !window.matchMedia) {
        return 'dark';
    }
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}
/**
 * Resolves the effective theme from preferences: isDarkTheme true → dark, false → light,
 * undefined → follow system preference.
 */
function getThemeFromPreferences() {
    const isDarkTheme = Preferences_1.default.get('isDarkTheme');
    if (isDarkTheme === false) {
        return 'light';
    }
    if (isDarkTheme === true) {
        return 'dark';
    }
    return getSystemTheme();
}
/**
 * React context providing the current UI theme (dark/light) for styling and assets.
 */
exports.ThemeContext = (0, react_1.createContext)(getThemeFromPreferences());
/**
 * Provider that uses the saved preference (isDarkTheme) when set, otherwise follows the system
 * theme. Reacts to preference changes and to system theme changes when preference is unset.
 */
const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = (0, react_1.useState)(getThemeFromPreferences);
    // Subscribe to preference changes (saved preferences and initial load)
    (0, react_1.useEffect)(() => {
        const onPreferencesChange = () => {
            setTheme(getThemeFromPreferences());
        };
        Preferences_1.default.addChangeListener(onPreferencesChange);
        return () => Preferences_1.default.removeChangeListener(onPreferencesChange);
    }, []);
    // React to system theme changes (getThemeFromPreferences uses system only when isDarkTheme is unset)
    (0, react_1.useEffect)(() => {
        if (typeof window === 'undefined' || !window.matchMedia)
            return;
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        const listener = () => setTheme(getThemeFromPreferences());
        media.addEventListener('change', listener);
        return () => media.removeEventListener('change', listener);
    }, []);
    // Apply theme to the document so CSS :root[data-color-scheme="dark|light"] takes effect
    (0, react_1.useEffect)(() => {
        if (typeof document !== 'undefined' && document.documentElement && theme !== undefined) {
            document.documentElement.setAttribute('data-color-scheme', theme);
        }
    }, [theme]);
    return react_1.default.createElement(exports.ThemeContext.Provider, { value: theme }, children);
};
exports.ThemeProvider = ThemeProvider;
//# sourceMappingURL=ThemeContext.js.map